import { ProjectRuntimeBehavior } from '~/projects/types';

const runtimeBehavior: ProjectRuntimeBehavior = {
  fetchSubscriptionEndpoint: false,
  createFunnelUserBeforeSignUp: true,
  fetchTrustpilotInviteUrl: false,
  subscriptionFromProfileOnly: true,
  showSubscriptionUsageBlocks: false,
  withOnboardingMiddleware: false,
  settingsMainLayoutNoSidebar: true,
  loadDesktopSidebarThemeToggle: true,
  chatVendorDefaultIsGpt51: true,
  chatVendorSelectorAvailableWithoutFeatureFlag: true,
  chatUsesGptShellLayout: true,
  chatAnonymousSessionsEnabled: true,
  chatUsesChatwithaiEndpoints: true,
  showFrozenSubscriptionBlock: false,
  showHomeRetentionPopover: false,
  showTrustpilotMentions: false,
  backendErrorsHandlingStrategy: 'polyllm_upgrade_paywall',
};

export default runtimeBehavior;
